module.exports = __webpack_public_path__ + "img/shared_with_me.a90de515.png";